import dayjs from 'dayjs';
import { MobileUnit, ZsdUser } from '@models';
import { universalUserLabelMapper } from '@utils';

export const getUnitName = (
  unit: MobileUnit | ZsdUser | undefined,
  unitType: 'mobileUnit' | 'user'
): string => {
  if (!unit) {
    return '';
  }
  if (unitType === 'mobileUnit') {
    return (unit as MobileUnit)?.name ?? '';
  }
  const user = unit as ZsdUser;
  return universalUserLabelMapper(user);
};

export const getCalendarLegendRowLabel = (day: dayjs.Dayjs): string =>
  new Date(day.toDate()).toLocaleDateString('sk-SK', {
    weekday: 'short',
    year: 'numeric',
    month: 'long',
    day: 'numeric',
  });
